export const APPLICATION_FIELD_PATHS = {
  APPLICATION: (applicationIndex: number) => `applications[${applicationIndex}]`,
  APPLICATIONS: () => `applications`,
  APPLICATION_CLONED_FROM_APPLICATION_ID: (applicationIndex: number) =>
    `applications[${applicationIndex}].clonedFromApplicationId`,
  APPLICATION_ADDITIONAL_STATUS: (applicationIndex: number) =>
    `applications[${applicationIndex}].progress.additionalStatus`,
  APPLICATION_APPLICANT_STATUS: (applicationIndex: number) =>
    `applications[${applicationIndex}].progress.applicantStatus`,
  APPLICATION_BROKER_PRIMARY_PURPOSE: (applicationIndex: number) =>
    `applications[${applicationIndex}].brokerPrimaryPurpose`,
  APPLICATION_PURCHASE_SITUATION: (applicationIndex: number) =>
    `applications[${applicationIndex}].preliminary.purchaseSituation`,
  APPLICATION_CASHOUT_AMOUNT: (applicationIndex: number) =>
    `applications[${applicationIndex}].preliminary.cashoutAmount`,
  APPLICATION_CLIENT_ID: (applicationIndex: number) => `applications[${applicationIndex}].clientId`,
  APPLICATION_COMPLETE_NUMBER: (applicationIndex: number) =>
    `applications[${applicationIndex}].progress.completeNumber`,
  APPLICATION_CONSOLIDATE_AMOUNT: (applicationIndex: number) =>
    `applications[${applicationIndex}].preliminary.consolidateAmount`,
  APPLICATION_CONTRIBUTION_AMOUNT: (applicationIndex: number, contributionsIndex: number) =>
    `applications[${applicationIndex}].preliminary.contributions[${contributionsIndex}].amount`,
  APPLICATION_CUSTOMER_ID: (applicationIndex: number) => `applications[${applicationIndex}].customerId`,
  APPLICATION_DESIRED_FEATURES: (applicationIndex: number) =>
    `applications[${applicationIndex}].preliminary.desiredFeatures`,
  APPLICATION_ELIGIBLE_FOR_FHOG: (applicationIndex: number) =>
    `applications[${applicationIndex}].preliminary.eligibleForFHOG`,
  APPLICATION_HIDDEN: (applicationIndex: number) => `applications[${applicationIndex}].hidden`,
  APPLICATION_ID: (applicationIndex: number) => `applications[${applicationIndex}].id`,
  APPLICATION_IS_SELLING_EXISTING_PROPERTY: (applicationIndex: number) =>
    `applications[${applicationIndex}].preliminary.isSellingExistingProperty`,
  APPLICATION_LENDER_IMG_URL: (applicationIndex: number) => `applications[${applicationIndex}].progress.lenderImgUrl`,
  APPLICATION_NAME: (applicationIndex: number) => `applications[${applicationIndex}].name`,
  APPLICATION_NUMBER_OF_DEPENDANTS: (applicationIndex: number) =>
    `applications[${applicationIndex}].preliminary.numberOfDependants`,
  APPLICATION_PAYMENT_TYPE: (applicationIndex: number) => `applications[${applicationIndex}].preliminary.paymentType`,
  APPLICATION_PRIMARY_APPLICANT_ID: (applicationIndex: number) =>
    `applications[${applicationIndex}].primaryApplicantId`,
  APPLICATION_PRIMARY_PURPOSE: (applicationIndex: number) =>
    `applications[${applicationIndex}].preliminary.primaryPurpose`,
  APPLICATION_PRODUCT_NAME: (applicationIndex: number) => `applications[${applicationIndex}].progress.productName`,
  APPLICATION_PURCHASE_REASONS: (applicationIndex: number) =>
    `applications[${applicationIndex}].preliminary.purchaseReason`,
  APPLICATION_REFINANCING_REASON: (applicationIndex: number, refinanceIndex: number) =>
    `applications[${applicationIndex}].preliminary.refinancingReasons[${refinanceIndex}]`,
  APPLICATION_REFINANCING_REASONS: (applicationIndex: number) =>
    `applications[${applicationIndex}].preliminary.refinancingReasons`,
  APPLICATION_URGENCY: (applicationIndex: number) => `applications[${applicationIndex}].preliminary.urgency`,
  APPLICATION_CREATED_AT: (applicationIndex: number) => `applications[${applicationIndex}].createdAt`,
  APPLICATION_HAS_OPTED_IN_RATE_LOCK: (applicationIndex: number) =>
    `applications[${applicationIndex}].hasOptedInRateLock`,
  APPLICATION_IS_FAST_REFI: (applicationIndex: number) => `applications[${applicationIndex}].isFastRefi`,
  APPLICATION_PREFERRED_REPAYMENT_METHOD: (applicationIndex: number) =>
    `applications[${applicationIndex}].preferredRepayment.method`,
  APPLICATION_PREFERRED_REPAYMENT_FREQUENCY: (applicationIndex: number) =>
    `applications[${applicationIndex}].preferredRepayment.frequency`,
  APPLICATION_PREFERRED_REPAYMENT_INSTITUTION_NAME: (applicationIndex: number) =>
    `applications[${applicationIndex}].preferredRepayment.institutionName`,
  APPLICATION_PREFERRED_REPAYMENT_ACCOUNT_NAME: (applicationIndex: number) =>
    `applications[${applicationIndex}].preferredRepayment.accountName`,
  APPLICATION_PREFERRED_REPAYMENT_BSB: (applicationIndex: number) =>
    `applications[${applicationIndex}].preferredRepayment.bsb`,
  APPLICATION_PREFERRED_REPAYMENT_ACCOUNT_NUMBER: (applicationIndex: number) =>
    `applications[${applicationIndex}].preferredRepayment.accountNumber`,
};

export const APPLICANT_FIELD_PATHS = {
  APPLICANT: (applicantIndex: number) => `applicants[${applicantIndex}]`,
  APPLICANTS: () => `applicants`,
  APPLICANT_CLIENT_ID: (applicantIndex: number) => `applicants[${applicantIndex}].clientId`,
  APPLICANT_CREDIT_STATUS: (applicantIndex: number) => `applicants[${applicantIndex}].creditStatus`,
  APPLICANT_MAILING_ADDRESS: (applicantIndex: number) => `applicants[${applicantIndex}].contact.mailingAddress`,
  APPLICANT_MAILING_ADDRESS_FORMATTED: (applicantIndex: number) =>
    `applicants[${applicantIndex}].contact.mailingAddress.formatted`,
  APPLICANT_CURRENT_ADDRESS: (applicantIndex: number) => `applicants[${applicantIndex}].contact.currentAddress`,
  APPLICANT_CURRENT_ADDRESS_RESIDENTIAL: (applicantIndex: number) =>
    `applicants[${applicantIndex}].contact.currentAddress.residentialAddress`,
  APPLICANT_CURRENT_ADDRESS_RESIDENTIAL_FORMATTED: (applicantIndex: number) =>
    `applicants[${applicantIndex}].contact.currentAddress.residentialAddress.formatted`,
  APPLICANT_CURRENT_ADDRESS_HOUSING_STATUS: (applicantIndex: number) =>
    `applicants[${applicantIndex}].contact.currentAddress.housingStatus`,
  APPLICANT_CURRENT_ADDRESS_START_DATE: (applicantIndex: number) =>
    `applicants[${applicantIndex}].contact.currentAddress.startDate`,
  APPLICANT_CUSTOMER_ID: (applicantIndex: number) => `applicants[${applicantIndex}].customerId`,
  APPLICANT_DATE_OF_BIRTH: (applicantIndex: number) => `applicants[${applicantIndex}].dateOfBirth`,
  APPLICANT_DEPENDANTS: (applicantIndex: number) => `applicants[${applicantIndex}].dependants`,
  APPLICANT_DEPENDANTS_AGE: (applicantIndex: number, dependantsIndex: number) =>
    `applicants[${applicantIndex}].dependants[${dependantsIndex}].age`,
  APPLICANT_DEPENDANTS_SHARE_WITH: (applicantIndex: number, dependantsIndex: number) =>
    `applicants[${applicantIndex}].dependants[${dependantsIndex}].sharedWith`,
  APPLICANT_DEPENDANTS_SHARE_WITH_APPLICANT_ID: (applicantIndex: number, dependantsIndex: number) =>
    `applicants[${applicantIndex}].dependants[${dependantsIndex}].sharedWith.applicantId`,
  APPLICANT_EMAIL: (applicantIndex: number) => `applicants[${applicantIndex}].contact.emailAddress`,
  APPLICANT_ENTITY: (applicantIndex: number) => `applicants[${applicantIndex}].entity`,
  APPLICANT_FIRST_NAME: (applicantIndex: number) => `applicants[${applicantIndex}].firstName`,
  APPLICANT_GENDER: (applicantIndex: number) => `applicants[${applicantIndex}].gender`,
  APPLICANT_GROSS_SALARY_AMOUNT: (applicantIndex: number) => `applicants[${applicantIndex}].totalIncomeEstimate`,
  APPLICANT_HAS_SELF_EMPLOYMENT_PROOF: (applicantIndex: number) =>
    `applicants[${applicantIndex}].hasSelfEmploymentProof`,
  APPLICANT_ID: (applicantIndex: number) => `applicants[${applicantIndex}].id`,
  APPLICANT_CLONED_FROM_APPLICANT_ID: (applicantIndex: number) => `applicants[${applicantIndex}].clonedFromApplicantId`,
  APPLICANT_INVITE_STATUS: (applicantIndex: number) => `applicants[${applicantIndex}].invitationStatus`,
  APPLICANT_LAST_NAME: (applicantIndex: number) => `applicants[${applicantIndex}].lastName`,
  APPLICANT_MARITAL_DETAILS: (applicantIndex: number) => `applicants[${applicantIndex}].maritalDetails`,
  APPLICANT_MARITAL_DETAILS_APPLICANT_ID: (applicantIndex: number) =>
    `applicants[${applicantIndex}].maritalDetails.applicantId`,
  APPLICANT_MARITAL_STATUS: (applicantIndex: number) => `applicants[${applicantIndex}].maritalStatus`,
  APPLICANT_MIDDLE_NAME: (applicantIndex: number) => `applicants[${applicantIndex}].middleName`,
  APPLICANT_MOBILE: (applicantIndex: number) => `applicants[${applicantIndex}].contact.mobileNumber`,
  APPLICANT_PREVIOUS_ADDRESSES: (applicantIndex: number) => `applicants[${applicantIndex}].contact.previousAddresses`,
  APPLICANT_PREVIOUS_ADDRESS: (applicantIndex: number, addressIndex: number) =>
    `applicants[${applicantIndex}].contact.previousAddresses[${addressIndex}]`,
  APPLICANT_PREVIOUS_ADDRESS_RESIDENTIAL: (applicantIndex: number, addressIndex: number) =>
    `applicants[${applicantIndex}].contact.previousAddresses[${addressIndex}].residentialAddress`,
  APPLICANT_PREVIOUS_ADDRESS_RESIDENTIAL_FORMATTED: (applicantIndex: number, addressIndex: number) =>
    `applicants[${applicantIndex}].contact.previousAddresses[${addressIndex}].residentialAddress.formatted`,
  APPLICANT_PREVIOUS_ADDRESS_HOUSING_STATUS: (applicantIndex: number, addressIndex: number) =>
    `applicants[${applicantIndex}].contact.previousAddresses[${addressIndex}].housingStatus`,
  APPLICANT_PREVIOUS_ADDRESS_START_DATE: (applicantIndex: number, addressIndex: number) =>
    `applicants[${applicantIndex}].contact.previousAddresses[${addressIndex}].startDate`,
  APPLICANT_PREVIOUS_ADDRESS_END_DATE: (applicantIndex: number, addressIndex: number) =>
    `applicants[${applicantIndex}].contact.previousAddresses[${addressIndex}].endDate`,
  APPLICANT_RESIDENCY_STATUS: (applicantIndex: number) => `applicants[${applicantIndex}].residencyStatus`,
  APPLICANT_TITLE: (applicantIndex: number) => `applicants[${applicantIndex}].title`,
  APPLICANT_TYPE: (applicantIndex: number) => `applicants[${applicantIndex}].applicantType`,
  APPLICANT_MOTHERS_MAIDEN_NAME: (applicantIndex: number) => `applicants[${applicantIndex}].mothersMaidenName`,
  APPLICANT_CITY_OF_BIRTH: (applicantIndex: number) => `applicants[${applicantIndex}].cityOfBirth`,
  APPLICANT_COUNTRY_OF_BIRTH: (applicantIndex: number) => `applicants[${applicantIndex}].countryOfBirth`,
  APPLICANT_CITIZENSHIP: (applicantIndex: number) => `applicants[${applicantIndex}].citizenship`,
  APPLICANT_POST_SETTLEMENT_ADDRESS: (applicantIndex: number) =>
    `applicants[${applicantIndex}].contact.postSettlementAddress`,
  APPLICANT_POST_SETTLEMENT_ADDRESS_FORMATTED: (applicantIndex: number) =>
    `applicants[${applicantIndex}].contact.postSettlementAddress.formatted`,
  APPLICANT_IS_FIRST_HOME_BUYER: (applicantIndex: number) => `applicants[${applicantIndex}].isFirstHomeBuyer`,
  APPLICANT_GUARANTOR_RELATIONSHIP_TO_BORROWER: (applicantIndex: number) =>
    `applicants[${applicantIndex}].guarantorRelationshipToBorrower`,
  APPLICANT_GUARANTOR_RELATIONSHIP_TO_BORROWER_APPLICANT_ID: (applicantIndex: number) =>
    `applicants[${applicantIndex}].guarantorRelationshipToBorrower.applicantId`,
  APPLICANT_GUARANTOR_RELATIONSHIP_TO_BORROWER_TYPE: (applicantIndex: number) =>
    `applicants[${applicantIndex}].guarantorRelationshipToBorrower.type`,
  APPLICANT_GUARANTOR_RELATIONSHIP_TO_BORROWER_TYPE_OTHER: (applicantIndex: number) =>
    `applicants[${applicantIndex}].guarantorRelationshipToBorrower.typeOther`,

  /**
   * Company
   */
  APPLICANT_COMPANY_NAME: (applicantIndex: number) => `applicants[${applicantIndex}].companyName`,
  APPLICANT_COMPANY_TYPE: (applicantIndex: number) => `applicants[${applicantIndex}].companyType`,
  APPLICANT_COMPANY_STRUCTURE: (applicantIndex: number) => `applicants[${applicantIndex}].companyStructure`,
  APPLICANT_COMPANY_INDUSTRY_CODE: (applicantIndex: number) => `applicants[${applicantIndex}].industryCode`,
  APPLICANT_COMPANY_ABN: (applicantIndex: number) => `applicants[${applicantIndex}].abn`,
  APPLICANT_COMPANY_ACN: (applicantIndex: number) => `applicants[${applicantIndex}].acn`,
  APPLICANT_COMPANY_NOT_REGISTERED__FOR_GST: (applicantIndex: number) =>
    `applicants[${applicantIndex}].isNotRegistered`,
  APPLICANT_COMPANY_REGISTERED_STATE: (applicantIndex: number) => `applicants[${applicantIndex}].registeredState`,
  APPLICANT_COMPANY_REGISTERED_DATE: (applicantIndex: number) => `applicants[${applicantIndex}].registeredDate`,
  APPLICANT_COMPANY_CURRENT_LENDER: (applicantIndex: number) => `applicants[${applicantIndex}].currentLender`,
  APPLICANT_COMPANY_LEGAL_ENTITIES_IN_GROUP: (applicantIndex: number) =>
    `applicants[${applicantIndex}].legalEntitiesInGroup`,
  APPLICANT_COMPANY_LEGAL_ENTITIES_WITH_CURRENT_LENDER: (applicantIndex: number) =>
    `applicants[${applicantIndex}].legalEntitiesWithCurrentLender`,
  APPLICANT_COMPANY_MONTHS_WITH_CURRENT_LENDER: (applicantIndex: number) =>
    `applicants[${applicantIndex}].monthsWithCurrentLender`,
  APPLICANT_COMPANY_YEARS_OF_TRADING: (applicantIndex: number) => `applicants[${applicantIndex}].yearsOfTrading`,
  APPLICANT_COMPANY_BRANCH: (applicantIndex: number) => `applicants[${applicantIndex}].branch`,
  APPLICANT_COMPANY_IS_DIVERSIFIED: (applicantIndex: number) => `applicants[${applicantIndex}].isDiversified`,
  APPLICANT_COMPANY_IS_PASSIVE_ENTITY: (applicantIndex: number) => `applicants[${applicantIndex}].isPassiveEntity`,
  APPLICANT_COMPANY_IS_COMMERCIAL_RELATIONSHIP: (applicantIndex: number) =>
    `applicants[${applicantIndex}].isCommercialRelationship`,
  APPLICANT_COMPANY_HAS_MORE_THAN_25_PERCENT_BUSINESS_WITH_ONE_CUSTOMER: (applicantIndex: number) =>
    `applicants[${applicantIndex}].hasMoreThan25PercentBusinessWithOneCustomer`,
  APPLICANT_COMPANY_MORE_THAN_25_PERCENT_BUSINESS_WITH_ONE_CUSTOMER_DETAILS: (applicantIndex: number) =>
    `applicants[${applicantIndex}].moreThan25PercentBusinessWithOneCustomerDetails`,
  APPLICANT_COMPANY_HAS_OUTSTANDING_TAX: (applicantIndex: number) => `applicants[${applicantIndex}].hasOutstandingTax`,
  APPLICANT_COMPANY_OUTSTANDING_TAX_DETAILS: (applicantIndex: number) =>
    `applicants[${applicantIndex}].outstandingTaxDetails`,
  APPLICANT_COMPANY_IS_PRINCIPAL_PLACE_OF_BUSINESS_LEASED: (applicantIndex: number) =>
    `applicants[${applicantIndex}].isPrincipalPlaceOfBusinessLeased`,
  APPLICANT_COMPANY_PRINCIPAL_PLACE_OF_BUSINESS_LEASED_DETAILS: (applicantIndex: number) =>
    `applicants[${applicantIndex}].principalPlaceOfBusinessLeasedDetails`,
  APPLICANT_COMPANY_DOES_TERM_LOAN_NEED_100_PERCENT_FUNDING: (applicantIndex: number) =>
    `applicants[${applicantIndex}].doesTermLoanNeed100PercentFunding`,
  APPLICANT_COMPANY_TERM_LOAN_NEED_100_PERCENT_FUNDING_DETAILS: (applicantIndex: number) =>
    `applicants[${applicantIndex}].termLoanNeed100PercentFundingDetails`,
  APPLICANT_COMPANY_IS_ACTING_AS_FRANCHISE: (applicantIndex: number) =>
    `applicants[${applicantIndex}].isActingAsFranchise`,
  APPLICANT_COMPANY_ACTING_AS_FRANCHISE_DETAILS: (applicantIndex: number) =>
    `applicants[${applicantIndex}].actingAsFranchiseDetails`,
  APPLICANT_COMPANY_IS_WORKING_IN_IMPORT_EXPORT: (applicantIndex: number) =>
    `applicants[${applicantIndex}].isWorkingInImportExport`,
  APPLICANT_COMPANY_WORKING_IN_IMPORT_EXPORT_DETAILS: (applicantIndex: number) =>
    `applicants[${applicantIndex}].workingInImportExportDetails`,
  APPLICANT_COMPANY_IS_INVESTING_IN_PROPERTY: (applicantIndex: number) =>
    `applicants[${applicantIndex}].isInvestingInProperty`,
  APPLICANT_COMPANY_INVESTING_IN_PROPERTY_DETAILS: (applicantIndex: number) =>
    `applicants[${applicantIndex}].investingInPropertyDetails`,
  APPLICANT_COMPANY_HAS_GOOD_CONDUCT: (applicantIndex: number) => `applicants[${applicantIndex}].hasGoodConduct`,
  APPLICANT_COMPANY_WAS_BANKRUPT_OR_INSOLVENT: (applicantIndex: number) =>
    `applicants[${applicantIndex}].wasBankruptOrInsolvent`,
  APPLICANT_COMPANY_HAS_PAST_OR_CURRENT_DEBTS: (applicantIndex: number) =>
    `applicants[${applicantIndex}].hasPastOrCurrentDebts`,
  APPLICANT_COMPANY_HAD_REPAYMENT_DIFFICULTY_OR_LEGAL_PROCEEDINGS: (applicantIndex: number) =>
    `applicants[${applicantIndex}].hadRepaymentDifficultyOrLegalProceedings`,
  APPLICANT_COMPANY_IS_US_CITIZEN_OR_RESIDENT: (applicantIndex: number) =>
    `applicants[${applicantIndex}].isUSCitizenOrResident`,
  APPLICANT_COMPANY_HAD_LATE_PAYMENTS_OR_ARREARS_OR_ADVERSE_CREDIT_HISTORY: (applicantIndex: number) =>
    `applicants[${applicantIndex}].hadLatePaymentsOrArrearsOrAdverseCreditHistory`,

  /**
   * Trust
   */
  APPLICANT_TRUST_NAME: (applicantIndex: number) => `applicants[${applicantIndex}].trustName`,
  APPLICANT_TRUST_TYPE: (applicantIndex: number) => `applicants[${applicantIndex}].trustType`,
  APPLICANT_TRUST_REGISTERED_DATE: (applicantIndex: number) => `applicants[${applicantIndex}].registeredDate`,
  APPLICANT_TRUST_REGISTERED_COUNTRY: (applicantIndex: number) => `applicants[${applicantIndex}].registeredCountry`,
  APPLICANT_TRUST_REGISTERED_ADDRESS: (applicantIndex: number) => `applicants[${applicantIndex}].registeredAddress`,
  APPLICANT_TRUST_REGISTERED_ADDRESS_CITY: (applicantIndex: number) =>
    `applicants[${applicantIndex}].registeredAddress.city`,
  APPLICANT_TRUST_REGISTERED_ADDRESS_COUNTRY: (applicantIndex: number) =>
    `applicants[${applicantIndex}].registeredAddress.country`,
  APPLICANT_TRUST_REGISTERED_ADDRESS_FORMATTED: (applicantIndex: number) =>
    `applicants[${applicantIndex}].registeredAddress.formatted`,
  APPLICANT_TRUST_REGISTERED_ADDRESS_LEVEL: (applicantIndex: number) =>
    `applicants[${applicantIndex}].registeredAddress.standard.level`,
  APPLICANT_TRUST_REGISTERED_ADDRESS_POSTCODE: (applicantIndex: number) =>
    `applicants[${applicantIndex}].registeredAddress.postcode`,
  APPLICANT_TRUST_REGISTERED_ADDRESS_STATE: (applicantIndex: number) =>
    `applicants[${applicantIndex}].registeredAddress.state`,
  APPLICANT_TRUST_REGISTERED_ADDRESS_STREET_NAME: (applicantIndex: number) =>
    `applicants[${applicantIndex}].registeredAddress.standard.streetName`,
  APPLICANT_TRUST_REGISTERED_ADDRESS_STREET_NUMBER: (applicantIndex: number) =>
    `applicants[${applicantIndex}].registeredAddress.standard.streetNumber`,
  APPLICANT_TRUST_REGISTERED_ADDRESS_STREET_TYPE: (applicantIndex: number) =>
    `applicants[${applicantIndex}].registeredAddress.standard.streetType`,
  APPLICANT_TRUST_REGISTERED_ADDRESS_UNIT: (applicantIndex: number) =>
    `applicants[${applicantIndex}].registeredAddress.standard.unit`,
  APPLICANT_TRUST_MAILING_ADDRESS: (applicantIndex: number) => `applicants[${applicantIndex}].mailingAddress`,
  APPLICANT_TRUST_MAILING_ADDRESS_CITY: (applicantIndex: number) => `applicants[${applicantIndex}].mailingAddress.city`,
  APPLICANT_TRUST_MAILING_ADDRESS_COUNTRY: (applicantIndex: number) =>
    `applicants[${applicantIndex}].mailingAddress.country`,
  APPLICANT_TRUST_MAILING_ADDRESS_FORMATTED: (applicantIndex: number) =>
    `applicants[${applicantIndex}].mailingAddress.formatted`,
  APPLICANT_TRUST_MAILING_ADDRESS_LEVEL: (applicantIndex: number) =>
    `applicants[${applicantIndex}].mailingAddress.standard.level`,
  APPLICANT_TRUST_MAILING_ADDRESS_POSTCODE: (applicantIndex: number) =>
    `applicants[${applicantIndex}].mailingAddress.postcode`,
  APPLICANT_TRUST_MAILING_ADDRESS_STATE: (applicantIndex: number) =>
    `applicants[${applicantIndex}].mailingAddress.state`,
  APPLICANT_TRUST_MAILING_ADDRESS_STREET_NAME: (applicantIndex: number) =>
    `applicants[${applicantIndex}].mailingAddress.standard.streetName`,
  APPLICANT_TRUST_MAILING_ADDRESS_STREET_NUMBER: (applicantIndex: number) =>
    `applicants[${applicantIndex}].mailingAddress.standard.streetNumber`,
  APPLICANT_TRUST_MAILING_ADDRESS_STREET_TYPE: (applicantIndex: number) =>
    `applicants[${applicantIndex}].mailingAddress.standard.streetType`,
  APPLICANT_TRUST_MAILING_ADDRESS_UNIT: (applicantIndex: number) =>
    `applicants[${applicantIndex}].mailingAddress.standard.unit`,
  APPLICANT_TRUST_INDUSTRY_CODE: (applicantIndex: number) => `applicants[${applicantIndex}].industryCode`,
  APPLICANT_TRUST_IS_PASSIVE_ENTITY: (applicantIndex: number) => `applicants[${applicantIndex}].isPassiveEntity`,
};

export const ASSET_FIELD_PATHS = {
  ASSET: (assetIndex: number) => `assets[${assetIndex}]`,
  ASSETS: () => `assets`,
  ASSET_ACCOUNT_NUMBER: (assetIndex: number) => `assets[${assetIndex}].financialInstitutionAccountNumber`,
  ASSET_ADDRESS: (assetIndex: number) => `assets[${assetIndex}].address`,
  ASSET_ADDRESS_COUNTRY: (assetIndex: number) => `assets[${assetIndex}].address.country`,
  ASSET_ADDRESS_STATE: (assetIndex: number) => `assets[${assetIndex}].address.state`,
  ASSET_AUSTRALIAN_POST_CODE: (assetIndex: number) => `assets[${assetIndex}].address.postcode`,
  ASSET_BSB: (assetIndex: number) => `assets[${assetIndex}].financialInstitutionBsb`,
  ASSET_CLIENT_ID: (assetIndex: number) => `assets[${assetIndex}].clientId`,
  ASSET_DESCRIPTION: (assetIndex: number) => `assets[${assetIndex}].description`,
  ASSET_CONTRACT_DATE: (assetIndex: number) => `assets[${assetIndex}].contractDetails.contractDate`,
  ASSET_ESTIMATED_SETTLEMENT_DATE: (assetIndex: number) =>
    `assets[${assetIndex}].contractDetails.estimatedSettlementDate`,
  ASSET_ESTIMATED_VALUE: (assetIndex: number) => `assets[${assetIndex}].estimatedValue`,
  ASSET_FINANCIAL_INSTITUTION: (assetIndex: number) => `assets[${assetIndex}].financialInstitution`,
  ASSET_FORMATTED_ADDRESS: (assetIndex: number) => `assets[${assetIndex}].address.formatted`,
  ASSET_ID: (assetIndex: number) => `assets[${assetIndex}].id`,
  ASSET_LIABILITY_CLIENT_ID: (assetIndex: number) => `assets[${assetIndex}].liabilityClientId`,
  ASSET_LIABILITY_ID: (assetIndex: number) => `assets[${assetIndex}].liabilityId`,
  ASSET_OWNERS: (assetIndex: number) => `assets[${assetIndex}].percentOwned.owners`,
  ASSET_OWNER: (assetIndex: number, ownerIndex: number) => `assets[${assetIndex}].percentOwned.owners[${ownerIndex}]`,
  ASSET_OWNER_APPLICANT_CLIENT_ID: (assetIndex: number, ownerIndex: number) =>
    `assets[${assetIndex}].percentOwned.owners[${ownerIndex}].applicantClientId`,
  ASSET_OWNER_APPLICANT_ID: (assetIndex: number, ownerIndex: number) =>
    `assets[${assetIndex}].percentOwned.owners[${ownerIndex}].applicantId`,
  ASSET_OWNER_CUSTOMER_ID: (assetIndex: number, ownerIndex: number) =>
    `assets[${assetIndex}].percentOwned.owners[${ownerIndex}].customerId`,
  ASSET_OWNER_PERCENT: (assetIndex: number, ownerIndex: number) =>
    `assets[${assetIndex}].percentOwned.owners[${ownerIndex}].percent`,
  ASSET_PERCENT_OWNED: (assetIndex: number) => `assets[${assetIndex}].percentOwned`,
  ASSET_PRIMARY_PURPOSE: (assetIndex: number) => `assets[${assetIndex}].primaryPurpose`,
  ASSET_PROPERTY_STATUS: (assetIndex: number) => `assets[${assetIndex}].propertyStatus`,
  ASSET_PROPERTY_TYPE: (assetIndex: number) => `assets[${assetIndex}].propertyType`,
  ASSET_PROPERTY_ZONING: (assetIndex: number) => `assets[${assetIndex}].zoneType`,
  ASSET_RENTAL_INCOME_AMOUNT: (assetIndex: number) => `assets[${assetIndex}].rentalIncome.amount`,
  ASSET_RENTAL_INCOME_COMMENTS: (assetIndex: number) => `assets[${assetIndex}].rentalIncome.comments`,
  ASSET_RENTAL_INCOME_FREQUENCY: (assetIndex: number) => `assets[${assetIndex}].rentalIncome.frequency`,
  ASSET_TO_BE_PURCHASED: (assetIndex: number) => `assets[${assetIndex}].toBePurchased`,
  ASSET_TO_BE_SOLD: (assetIndex: number) => `assets[${assetIndex}].toBeSold`,
  ASSET_TYPE: (assetIndex: number) => `assets[${assetIndex}].type`,
  ASSET_USED_AS_SECURITY: (assetIndex: number) => `assets[${assetIndex}].toBeUsedAsSecurity`,
  ASSET_VEHICLE_MAKE: (assetIndex: number) => `assets[${assetIndex}].make`,
  ASSET_VEHICLE_YEAR: (assetIndex: number) => `assets[${assetIndex}].year`,
  // construction
  ASSET_IS_CONSTRUCTION: (assetIndex: number) => `assets[${assetIndex}].isConstruction`,
  ASSET_CONSTRUCTION_DETAILS: (assetIndex: number) => `assets[${assetIndex}].constructionDetails`,
  ASSET_BUILD_PRICE_AMOUNT: (assetIndex: number) => `assets[${assetIndex}].constructionDetails.buildPriceAmount`,
  ASSET_LAND_VALUE: (assetIndex: number) => `assets[${assetIndex}].constructionDetails.landEstimatedValue`,
  ASSET_BUILD_IN_6_MONTHS: (assetIndex: number) => `assets[${assetIndex}].constructionDetails.buildIn6Months`,
  ASSET_CONSTRUCTION_TYPE: (assetIndex: number) => `assets[${assetIndex}].constructionDetails.constructionType`,
  ASSET_OTHER_CONSTRUCTION_COSTS: (assetIndex: number) =>
    `assets[${assetIndex}].constructionDetails.otherConstructionCosts`,
  ASSET_IS_APPROVED_COUNCIL_PLANS_HELD: (assetIndex: number) =>
    `assets[${assetIndex}].constructionDetails.isApprovedCouncilPlansHeld`,
  ASSET_IS_SATISFACTORY_TOC_VALUATION_HELD: (assetIndex: number) =>
    `assets[${assetIndex}].constructionDetails.isSatisfactoryTOCValuationHeld`,
  ASSET_BUILDER_TYPE: (assetIndex: number) => `assets[${assetIndex}].constructionDetails.builderType`,
  ASSET_IS_INSURANCE_HELD: (assetIndex: number) => `assets[${assetIndex}].constructionDetails.isInsuranceHeld`,
  ASSET_IS_FIXED_PRICE_CONTRACT: (assetIndex: number) =>
    `assets[${assetIndex}].constructionDetails.isFixedPriceContract`,
  ASSET_PROPERTY_EXPENSES: (assetIndex: number) => `assets[${assetIndex}].propertyExpenses`,
  ASSET_PROPERTY_EXPENSE_DESCRIPTION: (assetIndex: number, propertyExpenseIndex: number) =>
    `assets[${assetIndex}].propertyExpenses[${propertyExpenseIndex}].description`,
  ASSET_PROPERTY_EXPENSE_AMOUNT: (assetIndex: number, propertyExpenseIndex: number) =>
    `assets[${assetIndex}].propertyExpenses[${propertyExpenseIndex}].amount`,
  ASSET_PROPERTY_EXPENSE_FREQUENCY: (assetIndex: number, propertyExpenseIndex: number) =>
    `assets[${assetIndex}].propertyExpenses[${propertyExpenseIndex}].frequency`,
  ASSET_PROPERTY_EXPENSE_COMMENTS: (assetIndex: number, propertyExpenseIndex: number) =>
    `assets[${assetIndex}].propertyExpenses[${propertyExpenseIndex}].comments`,
  ASSET_PROPERTY_EXPENSE_TYPE: (assetIndex: number, propertyExpenseIndex: number) =>
    `assets[${assetIndex}].propertyExpenses[${propertyExpenseIndex}].type`,
};

export const CUSTOMER_FIELD_PATHS = {
  CUSTOMER: (customerIndex: number) => `customers[${customerIndex}]`,
  CUSTOMERS: () => `customers`,
  CUSTOMER_EMAIL: (customerIndex: number) => `customers[${customerIndex}].email`,
  CUSTOMER_FIRST_NAME: (customerIndex: number) => `customers[${customerIndex}].firstName`,
  CUSTOMER_ID: (customerIndex: number) => `customers[${customerIndex}].id`,
  CUSTOMER_PHONE: (customerIndex: number) => `customers[${customerIndex}].mobileNumber`,
};

export const COMPANIES_FIELD_PATHS = {
  COMPANY: (companyIndex: number) => `companies[${companyIndex}]`,
  COMPANIES: () => 'companies',
  COMPANY_ID: (companyIndex: number) => `companies[${companyIndex}].id`,
  COMPANY_TYPE: (companyIndex: number) => `companies[${companyIndex}].type`,
  COMPANY_CLIENT_ID: (companyIndex: number) => `companies[${companyIndex}].clientId`,
  COMPANY_ABN: (companyIndex: number) => `companies[${companyIndex}].abn`,
  COMPANY_ABN_VERIFIED: (companyIndex: number) => `companies[${companyIndex}].abnVerified`,
  COMPANY_BUSINESS_NAME: (companyIndex: number) => `companies[${companyIndex}].businessName`,
  COMPANY_BUSINESS_STRUCTURE: (companyIndex: number) => `companies[${companyIndex}].businessStructure`,
  COMPANY_FOREIGN_COMPANY: (companyIndex: number) => `companies[${companyIndex}].foreignCompany`,
  COMPANY_PHONE_NUMBER: (companyIndex: number) => `companies[${companyIndex}].phone`,
  COMPANY_PRIVATE_OR_PUBLIC: (companyIndex: number) => `companies[${companyIndex}].privateOrPublic`,
  COMPANY_TRUST_TYPE: (companyIndex: number) => `companies[${companyIndex}].trustType`,
  COMPANY_GST_REGISTERED_DATE: (companyIndex: number) => `companies[${companyIndex}].gstRegisteredDate`,
  COMPANY_OWNERS: (companyIndex: number) => `companies[${companyIndex}].owners`,
  COMPANY_OWNER: (companyIndex: number, ownerIndex: number) => `companies[${companyIndex}].owners[${ownerIndex}]`,
  COMPANY_OWNER_APPLICANT_ID: (companyIndex: number, ownerIndex: number) =>
    `companies[${companyIndex}].owners[${ownerIndex}].applicantId`,
  COMPANY_OWNER_PERCENT_OWNED: (companyIndex: number, ownerIndex: number) =>
    `companies[${companyIndex}].owners[${ownerIndex}].percentOwned`,
  COMPANY_ADDRESS: (companyIndex: number) => `companies[${companyIndex}].address`,
  COMPANY_ADDRESS_CITY: (companyIndex: number) => `companies[${companyIndex}].address.city`,
  COMPANY_ADDRESS_COUNTRY: (companyIndex: number) => `companies[${companyIndex}].address.country`,
  COMPANY_ADDRESS_FORMATTED: (companyIndex: number) => `companies[${companyIndex}].address.formatted`,
  COMPANY_ADDRESS_LEVEL: (companyIndex: number) => `companies[${companyIndex}].address.standard.level`,
  COMPANY_ADDRESS_POSTCODE: (companyIndex: number) => `companies[${companyIndex}].address.postcode`,
  COMPANY_ADDRESS_STATE: (companyIndex: number) => `companies[${companyIndex}].address.state`,
  COMPANY_ADDRESS_STREET_NAME: (companyIndex: number) => `companies[${companyIndex}].address.standard.streetName`,
  COMPANY_ADDRESS_STREET_NUMBER: (companyIndex: number) => `companies[${companyIndex}].address.standard.streetNumber`,
  COMPANY_ADDRESS_STREET_TYPE: (companyIndex: number) => `companies[${companyIndex}].address.standard.streetType`,
  COMPANY_ADDRESS_UNIT: (companyIndex: number) => `companies[${companyIndex}].address.standard.unit`,
};

export const INCOMES_FIELD_PATHS = {
  INCOME: (incomeIndex: number) => `incomes[${incomeIndex}]`,
  INCOME_ID: (incomeIndex: number) => `incomes[${incomeIndex}].id`,
  INCOME_CLIENT_ID: (incomeIndex: number) => `incomes[${incomeIndex}].clientId`,
  INCOMES: () => 'incomes',
  INCOME_AMOUNT: (incomeIndex: number) => `incomes[${incomeIndex}].amount`,
  INCOME_ASSET_ID: (incomeIndex: number) => `incomes[${incomeIndex}].assetId`,
  INCOME_COMPANY_ID: (incomeIndex: number) => `incomes[${incomeIndex}].companyId`,
  INCOME_COMPANY_CLIENT_ID: (incomeIndex: number) => `incomes[${incomeIndex}].companyClientId`,
  INCOME_BENEFIT_TYPE: (incomeIndex: number) => `incomes[${incomeIndex}].benefitType`,
  INCOME_COMMENTS: (incomeIndex: number) => `incomes[${incomeIndex}].comments`,
  INCOME_DESCRIPTION: (incomeIndex: number) => `incomes[${incomeIndex}].description`,
  INCOME_EMPLOYMENT_ID: (incomeIndex: number) => `incomes[${incomeIndex}].employmentId`,
  INCOME_EMPLOYMENT_CLIENT_ID: (incomeIndex: number) => `incomes[${incomeIndex}].employmentClientId`,
  INCOME_FREQUENCY: (incomeIndex: number) => `incomes[${incomeIndex}].frequency`,
  INCOME_OWNERS: (incomeIndex: number) => `incomes[${incomeIndex}].percentOwned.owners`,
  INCOME_OWNER_APPLICANT_CLIENT_ID: (incomeIndex: number, ownerIndex: number) =>
    `incomes[${incomeIndex}].percentOwned.owners[${ownerIndex}].applicantClientId`,
  INCOME_OWNER_APPLICANT_ID: (incomeIndex: number, ownerIndex: number) =>
    `incomes[${incomeIndex}].percentOwned.owners[${ownerIndex}].applicantId`,
  INCOME_OWNER_PERCENT: (incomeIndex: number, ownerIndex: number) =>
    `incomes[${incomeIndex}].percentOwned.owners[${ownerIndex}].percent`,
  INCOME_PERCENT_OWNED: (incomeIndex: number) => `incomes[${incomeIndex}].percentOwned`,
  INCOME_TYPE: (incomeIndex: number) => `incomes[${incomeIndex}].type`,
  INCOME_BUSINESS_INCOME: (incomeIndex: number, businessIncomeIndex: number) =>
    `incomes[${incomeIndex}].incomes[${businessIncomeIndex}]`,
  INCOME_BUSINESS_INCOMES: (incomeIndex: number) => `incomes[${incomeIndex}].incomes`,
  INCOME_BUSINESS_INCOME_YEAR: (incomeIndex: number, businessIncomeIndex: number) =>
    `incomes[${incomeIndex}].incomes[${businessIncomeIndex}].year`,
  INCOME_BUSINESS_INCOME_COMPANY_PROFIT_BEFORE_TAX: (incomeIndex: number, businessIncomeIndex: number) =>
    `incomes[${incomeIndex}].incomes[${businessIncomeIndex}].companyProfitBeforeTax`,
  INCOME_BUSINESS_INCOME_DEDUCTION: (incomeIndex: number, businessIncomeIndex: number) =>
    `incomes[${incomeIndex}].incomes[${businessIncomeIndex}].nonRecurringIncome`,
  INCOME_BUSINESS_INCOME_ADD_BACK: (incomeIndex: number, businessIncomeIndex: number) =>
    `incomes[${incomeIndex}].incomes[${businessIncomeIndex}].addback`,
  INCOME_BUSINESS_INCOME_ADD_BACK_DEPRECIATION: (incomeIndex: number, businessIncomeIndex: number) =>
    `incomes[${incomeIndex}].incomes[${businessIncomeIndex}].addback.depreciation`,
  INCOME_BUSINESS_INCOME_ADD_BACK_INTEREST: (incomeIndex: number, businessIncomeIndex: number) =>
    `incomes[${incomeIndex}].incomes[${businessIncomeIndex}].addback.interest`,
  INCOME_BUSINESS_INCOME_ADD_BACK_LEASE: (incomeIndex: number, businessIncomeIndex: number) =>
    `incomes[${incomeIndex}].incomes[${businessIncomeIndex}].addback.lease`,
  INCOME_BUSINESS_INCOME_ADD_BACK_NON_RECURRING_EXPENSES: (incomeIndex: number, businessIncomeIndex: number) =>
    `incomes[${incomeIndex}].incomes[${businessIncomeIndex}].addback.nonRecurringExpenses`,
  INCOME_BUSINESS_INCOME_ADD_BACK_SALARY: (incomeIndex: number, businessIncomeIndex: number) =>
    `incomes[${incomeIndex}].incomes[${businessIncomeIndex}].addback.salary`,
  INCOME_BUSINESS_INCOME_ADD_BACK_SUPERANNUATION_EXCESS: (incomeIndex: number, businessIncomeIndex: number) =>
    `incomes[${incomeIndex}].incomes[${businessIncomeIndex}].addback.superannuationExcess`,
  INCOME_BUSINESS_INCOME_ADD_BACK_OTHER: (incomeIndex: number, businessIncomeIndex: number) =>
    `incomes[${incomeIndex}].incomes[${businessIncomeIndex}].addback.other`,
  INCOME_BUSINESS_ADDBACK_COMMENTS: (incomeIndex: number) => `incomes[${incomeIndex}].addbackComments`,
  INCOME_BUSINESS_DEDUCTION_COMMENTS: (incomeIndex: number) => `incomes[${incomeIndex}].deductionComments`,
  INCOME_BUSINESS_GROSS: (incomeIndex: number) => `incomes[${incomeIndex}].gross`,
  INCOME_BUSINESS_BASES: (incomeIndex: number) => `incomes[${incomeIndex}].bas`,
  INCOME_BUSINESS_BAS: (incomeIndex: number, basIndex: number) => `incomes[${incomeIndex}].bas[${basIndex}]`,
  INCOME_BUSINESS_BAS_QUARTER: (incomeIndex: number, basIndex: number) =>
    `incomes[${incomeIndex}].bas[${basIndex}].quarter`,
  INCOME_BUSINESS_BAS_SALES_AMOUNT: (incomeIndex: number, basIndex: number) =>
    `incomes[${incomeIndex}].bas[${basIndex}].salesAmount`,
};

export const INVITATIONS_FIELD_PATHS = {
  INVITATION: (inviteIndex: number) => `invitations[${inviteIndex}]`,
  INVITATIONS: () => `invitations`,
};

export const LIABILITY_FIELD_PATHS = {
  LIABILITIES: () => `liabilities`,
  LIABILITY: (liabilityIndex: number) => `liabilities[${liabilityIndex}]`,
  LIABILITY_ACCOUNT_NUMBER: (liabilityIndex: number) =>
    `liabilities[${liabilityIndex}].financialInstitutionAccountNumber`,
  LIABILITY_ASSET_CLIENT_ID: (liabilityIndex: number) => `liabilities[${liabilityIndex}].assetClientId`,
  LIABILITY_ASSET_ID: (liabilityIndex: number) => `liabilities[${liabilityIndex}].assetId`,
  LIABILITY_BALLOON_REPAYMENT_AMOUNT: (liabilityIndex: number) =>
    `liabilities[${liabilityIndex}].balloonRepaymentAmount`,
  LIABILITY_BSB: (liabilityIndex: number) => `liabilities[${liabilityIndex}].financialInstitutionBsb`,
  LIABILITY_CLEARING_FROM_OTHER_SOURCE: (liabilityIndex: number) =>
    `liabilities[${liabilityIndex}].clearingFromOtherSource`,
  LIABILITY_CLEARING_FROM_THIS_LOAN: (liabilityIndex: number) => `liabilities[${liabilityIndex}].clearingFromThisLoan`,
  LIABILITY_CLIENT_ID: (liabilityIndex: number) => `liabilities[${liabilityIndex}].clientId`,
  LIABILITY_CREDIT_LIMIT: (liabilityIndex: number) => `liabilities[${liabilityIndex}].creditLimit`,
  LIABILITY_DESCRIPTION: (assetIndex: number) => `liabilities[${assetIndex}].description`,
  LIABILITY_FINANCIAL_INSTITUTION: (liabilityIndex: number) => `liabilities[${liabilityIndex}].financialInstitution`,
  LIABILITY_FINANCIAL_INSTITUTION_SHORT_NAME: (liabilityIndex: number) =>
    `liabilities[${liabilityIndex}].financialInstitutionShortName`,
  LIABILITY_FIXED_TERM_EXPIRY_DATE: (liabilityIndex: number) => `liabilities[${liabilityIndex}].fixedTermExpiryDate`,
  LIABILITY_ID: (liabilityIndex: number) => `liabilities[${liabilityIndex}].id`,
  LIABILITY_INTEREST_RATE: (liabilityIndex: number) => `liabilities[${liabilityIndex}].annualInterestRate`,
  LIABILITY_INTEREST_TYPE: (liabilityIndex: number) => `liabilities[${liabilityIndex}].interestType`,
  LIABILITY_INTEREST_TYPE_DURATION: (liabilityIndex: number) => `liabilities[${liabilityIndex}].interestTypeDuration`,
  LIABILITY_INTEREST_ONLY_DURATION: (liabilityIndex: number) => `liabilities[${liabilityIndex}].interestOnlyDuration`,
  LIABILITY_INTEREST_ONLY_REMAINING_TERM: (liabilityIndex: number) =>
    `liabilities[${liabilityIndex}].interestOnlyRemainingTerm`,
  LIABILITY_NEW_LIMIT: (liabilityIndex: number) => `liabilities[${liabilityIndex}].newLimit`,
  LIABILITY_OUTSTANDING_BALANCE: (liabilityIndex: number) => `liabilities[${liabilityIndex}].outstandingBalance`,
  LIABILITY_OWNERS: (liabilityIndex: number) => `liabilities[${liabilityIndex}].percentOwned.owners`,
  LIABILITY_OWNER: (liabilityIndex: number, ownerIndex: number) =>
    `liabilities[${liabilityIndex}].percentOwned.owners[${ownerIndex}]`,
  LIABILITY_OWNER_APPLICANT_CLIENT_ID: (liabilityIndex: number, ownerIndex: number) =>
    `liabilities[${liabilityIndex}].percentOwned.owners[${ownerIndex}].applicantClientId`,
  LIABILITY_OWNER_APPLICANT_ID: (liabilityIndex: number, ownerIndex: number) =>
    `liabilities[${liabilityIndex}].percentOwned.owners[${ownerIndex}].applicantId`,
  LIABILITY_OWNER_CUSTOMER_ID: (liabilityIndex: number, ownerIndex: number) =>
    `liabilities[${liabilityIndex}].percentOwned.owners[${ownerIndex}].customerId`,
  LIABILITY_PERCENT_OWNED: (assetIndex: number) => `liabilities[${assetIndex}].percentOwned`,
  LIABILITY_REMAINING_TERM: (liabilityIndex: number) => `liabilities[${liabilityIndex}].remainingTermDuration`,
  LIABILITY_REPAYMENT_FREQUENCY: (liabilityIndex: number) => `liabilities[${liabilityIndex}].repaymentFrequency`,
  LIABILITY_REPAYMENT_TYPE: (liabilityIndex: number) => `liabilities[${liabilityIndex}].repaymentTypeDetails`,
  LIABILITY_REPAYMENT_VALUE: (liabilityIndex: number) => `liabilities[${liabilityIndex}].repaymentAmount`,
  LIABILITY_TYPE: (liabilityIndex: number) => `liabilities[${liabilityIndex}].type`,
  LIABILITY_TO_BE_TOPPED_UP: (liabilityIndex: number) => `liabilities[${liabilityIndex}].toBeToppedUp`,
  LIABILITY_LINKED_CREDIT_REPORT_ACCOUNT_ID: (liabilityIndex: number) =>
    `liabilities[${liabilityIndex}].linkedCreditReportAccountId`,
};

export const EMPLOYMENT_FIELD_PATHS = {
  EMPLOYMENTS: () => 'employments',
  EMPLOYMENT: (employmentIndex: number) => `employments[${employmentIndex}]`,
  EMPLOYMENT_ID: (employmentIndex: number) => `employments[${employmentIndex}].id`,
  EMPLOYMENT_CLIENT_ID: (employmentIndex: number) => `employments[${employmentIndex}].clientId`,
  EMPLOYMENT_ABN: (employmentIndex: number) => `employments[${employmentIndex}].abn`,
  EMPLOYMENT_ABN_VERIFIED: (employmentIndex: number) => `employments[${employmentIndex}].abnVerified`,
  EMPLOYMENT_ABN_GST_REGISTERED_DATE: (employmentIndex: number) => `employments[${employmentIndex}].gstRegisteredDate`,
  EMPLOYMENT_APPLICANT_ID: (employmentIndex: number) => `employments[${employmentIndex}].applicantId`,
  EMPLOYMENT_APPLICATION_ID: (employmentIndex: number) => `employments[${employmentIndex}].applicationId`,
  EMPLOYMENT_COMPANY_ID: (employmentIndex: number) => `employments[${employmentIndex}].companyId`,
  EMPLOYMENT_COMPANY_CLIENT_ID: (employmentIndex: number) => `employments[${employmentIndex}].companyClientId`,
  EMPLOYMENT_EMPLOYMENT_SUB_TYPE: (employmentIndex: number) => `employments[${employmentIndex}].subType`,
  EMPLOYMENT_BUSINESS_NAME: (employmentIndex: number) => `employments[${employmentIndex}].businessName`,
  EMPLOYMENT_BUSINESS_STRUCTURE: (employmentIndex: number) => `employments[${employmentIndex}].businessStructure`,
  EMPLOYMENT_EMPLOYER_ADDRESS: (employmentIndex: number) => `employments[${employmentIndex}].employerAddress`,
  EMPLOYMENT_EMPLOYER_ADDRESS_CITY: (employmentIndex: number) => `employments[${employmentIndex}].employerAddress.city`,
  EMPLOYMENT_EMPLOYER_ADDRESS_COUNTRY: (employmentIndex: number) =>
    `employments[${employmentIndex}].employerAddress.country`,
  EMPLOYMENT_EMPLOYER_ADDRESS_FORMATTED: (employmentIndex: number) =>
    `employments[${employmentIndex}].employerAddress.formatted`,
  EMPLOYMENT_EMPLOYER_ADDRESS_LEVEL: (employmentIndex: number) =>
    `employments[${employmentIndex}].employerAddress.standard.level`,
  EMPLOYMENT_EMPLOYER_ADDRESS_POSTCODE: (employmentIndex: number) =>
    `employments[${employmentIndex}].employerAddress.postcode`,
  EMPLOYMENT_EMPLOYER_ADDRESS_STATE: (employmentIndex: number) =>
    `employments[${employmentIndex}].employerAddress.state`,
  EMPLOYMENT_EMPLOYER_ADDRESS_STREET_NAME: (employmentIndex: number) =>
    `employments[${employmentIndex}].employerAddress.standard.streetName`,
  EMPLOYMENT_EMPLOYER_ADDRESS_STREET_NUMBER: (employmentIndex: number) =>
    `employments[${employmentIndex}].employerAddress.standard.streetNumber`,
  EMPLOYMENT_EMPLOYER_ADDRESS_STREET_TYPE: (employmentIndex: number) =>
    `employments[${employmentIndex}].employerAddress.standard.streetType`,
  EMPLOYMENT_EMPLOYER_ADDRESS_UNIT: (employmentIndex: number) =>
    `employments[${employmentIndex}].employerAddress.standard.unit`,
  EMPLOYMENT_EMPLOYMENT_BASIS: (employmentIndex: number) => `employments[${employmentIndex}].employmentBasis`,
  EMPLOYMENT_EMPLOYMENT_TYPE: (employmentIndex: number) => `employments[${employmentIndex}].employmentType`,
  EMPLOYMENT_FOREIGN_EMPLOYED: (employmentIndex: number) => `employments[${employmentIndex}].foreignEmployed`,
  EMPLOYMENT_MATERNITY_LEAVE_RETURN_BASIS: (employmentIndex: number) =>
    `employments[${employmentIndex}].maternityLeaveReturnBasis`,
  EMPLOYMENT_MATERNITY_LEAVE_RETURN_DATE: (employmentIndex: number) =>
    `employments[${employmentIndex}].maternityLeaveReturnDate`,
  EMPLOYMENT_ON_PROBATION: (employmentIndex: number) => `employments[${employmentIndex}].onProbation`,
  EMPLOYMENT_PRIVATE_OR_PUBLIC: (employmentIndex: number) => `employments[${employmentIndex}].privateOrPublic`,
  EMPLOYMENT_ROLE: (employmentIndex: number) => `employments[${employmentIndex}].role`,
  EMPLOYMENT_ROLE_ANZSCO_CODE: (employmentIndex: number) => `employments[${employmentIndex}].role.anzsco.code`,
  EMPLOYMENT_ROLE_ANZSCO_OCCUPATION: (employmentIndex: number) =>
    `employments[${employmentIndex}].role.anzsco.occupation`,
  EMPLOYMENT_ROLE_ANZSCO_CATEGORY: (employmentIndex: number) => `employments[${employmentIndex}].role.anzsco.category`,
  EMPLOYMENT_ROLE_ANSCO_CODE: (employmentIndex: number) => `employments[${employmentIndex}].role.asco.code`,
  EMPLOYMENT_ROLE_ANSCO_OCCUPATION: (employmentIndex: number) => `employments[${employmentIndex}].role.asco.occupation`,
  EMPLOYMENT_ROLE_ANSCO_CATEGORY: (employmentIndex: number) => `employments[${employmentIndex}].role.asco.category`,
  EMPLOYMENT_START_DATE: (employmentIndex: number) => `employments[${employmentIndex}].startDate`,
  EMPLOYMENT_END_DATE: (employmentIndex: number) => `employments[${employmentIndex}].endDate`,
  EMPLOYMENT_TYPE: (employmentIndex: number) => `employments[${employmentIndex}].type`,
};

export const EXPENSE_FIELD_PATHS = {
  EXPENSES: () => `expenses`,
  EXPENSE: (expensesIndex: number) => `expenses[${expensesIndex}]`,
  EXPENSES_CLIENT_ID: (expensesIndex: number) => `expenses[${expensesIndex}].clientId`,
  EXPENSES_APPLICANT_ID: (expensesIndex: number) => `expenses[${expensesIndex}].applicantId`,
  EXPENSES_GROUPED_APPLICANT_ID: (expensesIndex: number) => `expenses[${expensesIndex}].groupedApplicantId`,
  EXPENSES_EXPENSES: (expensesIndex: number) => `expenses[${expensesIndex}].expenses`,
  EXPENSES_EXPENSE_DESCRIPTION: (expensesIndex: number, expenseIndex: number) =>
    `expenses[${expensesIndex}].expenses[${expenseIndex}].description`,
  EXPENSES_EXPENSE_AMOUNT: (expensesIndex: number, expenseIndex: number) =>
    `expenses[${expensesIndex}].expenses[${expenseIndex}].amount`,
  EXPENSES_EXPENSE_FREQUENCY: (expensesIndex: number, expenseIndex: number) =>
    `expenses[${expensesIndex}].expenses[${expenseIndex}].frequency`,
  EXPENSES_EXPENSE_COMMENTS: (expensesIndex: number, expenseIndex: number) =>
    `expenses[${expensesIndex}].expenses[${expenseIndex}].comments`,
  EXPENSES_EXPENSE_TYPE: (expensesIndex: number, expenseIndex: number) =>
    `expenses[${expensesIndex}].expenses[${expenseIndex}].type`,
};

export const PRODUCT_PREFERENCE_FIELD_PATHS = {
  PRODUCT_PREFERENCES: () => `productPreferences`,
  PRODUCT_PREFERENCE: (productPreferencesIndex: number) => `productPreferences[${productPreferencesIndex}]`,
  PRODUCT_PREFERENCE_CLIENT_ID: (productPreferencesIndex: number) =>
    `productPreferences[${productPreferencesIndex}].clientId`,
  PRODUCT_PREFERENCE_APPLICATION_ID: (productPreferencesIndex: number) =>
    `productPreferences[${productPreferencesIndex}].applicationId`,
  PRODUCT_PREFERENCE_IS_REFINANCE: (productPreferencesIndex: number) =>
    `productPreferences[${productPreferencesIndex}].isRefinance`,
  PRODUCT_PREFERENCE_EXTRA_REPAYMENTS: (productPreferencesIndex: number) =>
    `productPreferences[${productPreferencesIndex}].extraRepayments`,
  PRODUCT_PREFERENCE_EXTRA_REPAYMENTS_OPTED: (productPreferencesIndex: number) =>
    `productPreferences[${productPreferencesIndex}].extraRepayments.opted`,
  PRODUCT_PREFERENCE_EXTRA_REPAYMENTS_AMOUNT: (productPreferencesIndex: number) =>
    `productPreferences[${productPreferencesIndex}].extraRepayments.amount`,
  PRODUCT_PREFERENCE_EXTRA_REPAYMENTS_FREQUENCY: (productPreferencesIndex: number) =>
    `productPreferences[${productPreferencesIndex}].extraRepayments.frequency`,
  PRODUCT_PREFERENCE_LENDER_BANKING_FEATURES: (productPreferencesIndex: number) =>
    `productPreferences[${productPreferencesIndex}].lenderBankingFeatures`,
  PRODUCT_PREFERENCE_LENDER_BANKING_FEATURE: (productPreferencesIndex: number, lenderBankingFeatureIndex: number) =>
    `productPreferences[${productPreferencesIndex}].lenderBankingFeatures[${lenderBankingFeatureIndex}]`,
  PRODUCT_PREFERENCE_REASONS: (productPreferencesIndex: number) =>
    `productPreferences[${productPreferencesIndex}].reason`,
  PRODUCT_PREFERENCE_REASON: (productPreferencesIndex: number, reasonIndex: number) =>
    `productPreferences[${productPreferencesIndex}].reason[${reasonIndex}]`,
  PRODUCT_PREFERENCE_REPAYMENT_TYPE_DETAILS: (productPreferencesIndex: number) =>
    `productPreferences[${productPreferencesIndex}].repaymentTypeDetails`,
  PRODUCT_PREFERENCE_REPAYMENT_TYPE_DETAILS_TYPE: (productPreferencesIndex: number) =>
    `productPreferences[${productPreferencesIndex}].repaymentTypeDetails.type`,
  PRODUCT_PREFERENCE_REPAYMENT_TYPE_DETAILS_DETAILS: (productPreferencesIndex: number) =>
    `productPreferences[${productPreferencesIndex}].repaymentTypeDetails.details`,
  PRODUCT_PREFERENCE_OTHER_PREFERENCES: (productPreferencesIndex: number) =>
    `productPreferences[${productPreferencesIndex}].otherPreferences`,
  PRODUCT_PREFERENCE_REPAYMENT_OPTIONS: (productPreferencesIndex: number) =>
    `productPreferences[${productPreferencesIndex}].repaymentOptions`,
  PRODUCT_PREFERENCE_REPAYMENT_OPTIONS_OPTION: (productPreferencesIndex: number, optionIndex: number) =>
    `productPreferences[${productPreferencesIndex}].repaymentOptions[${optionIndex}].option`,
  PRODUCT_PREFERENCE_REPAYMENT_OPTIONS_DESCRIPTION: (productPreferencesIndex: number, optionIndex: number) =>
    `productPreferences[${productPreferencesIndex}].repaymentOptions[${optionIndex}].description`,
  PRODUCT_PREFERENCE_LOAN_TERM: (productPreferencesIndex: number) =>
    `productPreferences[${productPreferencesIndex}].loanTerm`,
  PRODUCT_PREFERENCE_REFINANCE_REASONS: (productPreferencesIndex: number) =>
    `productPreferences[${productPreferencesIndex}].refinanceReasons`,
  PRODUCT_PREFERENCE_REFINANCE_REASON: (productPreferencesIndex: number, refinanceReasonIndex: number) =>
    `productPreferences[${productPreferencesIndex}].refinanceReasons[${refinanceReasonIndex}]`,
  PRODUCT_PREFERENCE_REFINANCE_REASON_REASON: (productPreferencesIndex: number, refinanceReasonIndex: number) =>
    `productPreferences[${productPreferencesIndex}].refinanceReasons[${refinanceReasonIndex}].reason`,
  PRODUCT_PREFERENCE_REFINANCE_REASON_DESCRIPTION: (productPreferencesIndex: number, refinanceReasonIndex: number) =>
    `productPreferences[${productPreferencesIndex}].refinanceReasons[${refinanceReasonIndex}].description`,
};

export const FINANCIAL_SITUATION_PATHS = {
  FINANCIAL_SITUATIONS: () => `financialSituations`,
  FINANCIAL_SITUATION: (financialSituationIndex: number) => `financialSituations[${financialSituationIndex}]`,
  FINANCIAL_SITUATION_CLIENT_ID: (financialSituationIndex: number) =>
    `financialSituations[${financialSituationIndex}].clientId`,
  FINANCIAL_SITUATION_APPLICANT_ID: (financialSituationIndex: number) =>
    `financialSituations[${financialSituationIndex}].applicantId`,
  FINANCIAL_SITUATION_APPLICATION_ID: (financialSituationIndex: number) =>
    `financialSituations[${financialSituationIndex}].applicationId`,
  FINANCIAL_SITUATION_MITIGANTS: (financialSituationIndex: number) =>
    `financialSituations[${financialSituationIndex}].mitigant`,
  FINANCIAL_SITUATION_MITIGANT: (financialSituationIndex: number, mitigantIndex: number) =>
    `financialSituations[${financialSituationIndex}].mitigant[${mitigantIndex}]`,
  FINANCIAL_SITUATION_MITIGANT_FACTOR: (financialSituationIndex: number, mitigantIndex: number) =>
    `financialSituations[${financialSituationIndex}].mitigant[${mitigantIndex}].factor`,
  FINANCIAL_SITUATION_MITIGANT_DESCRIPTION: (financialSituationIndex: number, mitigantIndex: number) =>
    `financialSituations[${financialSituationIndex}].mitigant[${mitigantIndex}].description`,
  FINANCIAL_SITUATION_PAYMENTISSUES: (financialSituationIndex: number) =>
    `financialSituations[${financialSituationIndex}].paymentIssues`,
  FINANCIAL_SITUATION_PAYMENTISSUE: (financialSituationIndex: number, paymentIssueIndex: number) =>
    `financialSituations[${financialSituationIndex}].paymentIssues[${paymentIssueIndex}]`,
  FINANCIAL_SITUATION_PAYMENTISSUE_TYPE: (financialSituationIndex: number, paymentIssueIndex: number) =>
    `financialSituations[${financialSituationIndex}].paymentIssues[${paymentIssueIndex}].type`,
  FINANCIAL_SITUATION_PAYMENTISSUE_DESCRIPTION: (financialSituationIndex: number, paymentIssueIndex: number) =>
    `financialSituations[${financialSituationIndex}].paymentIssues[${paymentIssueIndex}].description`,
  FINANCIAL_SITUATION_RETIREMENTDETAILS: (financialSituationIndex: number) =>
    `financialSituations[${financialSituationIndex}].retirementDetails`,
  FINANCIAL_SITUATION_RETIREMENTDETAILS_AGE: (financialSituationIndex: number) =>
    `financialSituations[${financialSituationIndex}].retirementDetails.age`,
  FINANCIAL_SITUATION_RETIREMENTDETAILS_DESCRIPTION: (financialSituationIndex: number) =>
    `financialSituations[${financialSituationIndex}].retirementDetails.description`,
  FINANCIAL_SITUATION_SIGNIFICANT_CHANGES: (financialSituationIndex: number) =>
    `financialSituations[${financialSituationIndex}].significantChanges`,
  FINANCIAL_SITUATION_SIGNIFICANT_CHANGE: (financialSituationIndex: number, significantChangeIndex: number) =>
    `financialSituations[${financialSituationIndex}].significantChanges[${significantChangeIndex}]`,
  FINANCIAL_SITUATION_SIGNIFICANT_CHANGE_TYPE: (financialSituationIndex: number, significantChangeIndex: number) =>
    `financialSituations[${financialSituationIndex}].significantChanges[${significantChangeIndex}].type`,
  FINANCIAL_SITUATION_SIGNIFICANT_CHANGE_DESCRIPTION: (
    financialSituationIndex: number,
    significantChangeIndex: number
  ) => `financialSituations[${financialSituationIndex}].significantChanges[${significantChangeIndex}].description`,
  FINANCIAL_SITUATION_SIGNIFICANT_CHANGE_START_DATE: (
    financialSituationIndex: number,
    significantChangeIndex: number
  ) => `financialSituations[${financialSituationIndex}].significantChanges[${significantChangeIndex}].startDate`,
  FINANCIAL_SITUATION_SIGNIFICANT_CHANGE_END_DATE: (financialSituationIndex: number, significantChangeIndex: number) =>
    `financialSituations[${financialSituationIndex}].significantChanges[${significantChangeIndex}].endDate`,
  FINANCIAL_SITUATION_SIGNIFICANT_CHANGE_ESTIMATED_IMPACT: (
    financialSituationIndex: number,
    significantChangeIndex: number
  ) => `financialSituations[${financialSituationIndex}].significantChanges[${significantChangeIndex}].estimatedImpact`,
  FINANCIAL_SITUATION_SIGNIFICANT_CHANGE_FREQUENCY: (financialSituationIndex: number, significantChangeIndex: number) =>
    `financialSituations[${financialSituationIndex}].significantChanges[${significantChangeIndex}].frequency`,
};

export const CREDIT_REPORT_FIELD_PATHS = {
  CREDIT_REPORTS: () => `creditReports`,
  CREDIT_REPORT_APPLICANT_ID: (creditReportIndex: number) => `creditReports[${creditReportIndex}].applicantId`,
  CREDIT_REPORT_PDF: (creditReportIndex: number) => `creditReports[${creditReportIndex}].pdf`,
  CREDIT_REPORT_CODE: (creditReportIndex: number) => `creditReports[${creditReportIndex}].code`,
  CREDIT_REPORT_MESSAGE: (creditReportIndex: number) => `creditReports[${creditReportIndex}].message`,
  CREDIT_REPORT_SCORE: (creditReportIndex: number) => `creditReports[${creditReportIndex}].scoreMasterScale`,
  CREDIT_REPORT_NUMBER_OF_IDENTITIES: (creditReportIndex: number) =>
    `creditReports[${creditReportIndex}].numberOfIdentities`,
  CREDIT_REPORT_PERSON_FIRST_NAME: (creditReportIndex: number) =>
    `creditReports[${creditReportIndex}].primaryMatch.firstName`,
  CREDIT_REPORT_PERSON_LAST_NAME: (creditReportIndex: number) =>
    `creditReports[${creditReportIndex}].primaryMatch.lastName`,
  CREDIT_REPORT_PERSON_DOB: (creditReportIndex: number) =>
    `creditReports[${creditReportIndex}].primaryMatch.dateOfBirth`,
  CREDIT_REPORT_PERSON_DRIVERS_LICENSE: (creditReportIndex: number) =>
    `creditReports[${creditReportIndex}].primaryMatch.driversLicense`,
  CREDIT_REPORT_PERSON_GENDER: (creditReportIndex: number) => `creditReports[${creditReportIndex}].primaryMatch.gender`,
  CREDIT_REPORT_SUMMARY: (creditReportIndex: number) => `creditReports[${creditReportIndex}].summary`,
  CREDIT_REPORT_CURRENT_DIRECTORSHIPS: (creditReportIndex: number) =>
    `creditReports[${creditReportIndex}].summary.currentDirectorships.value`,
  CREDIT_REPORT_PREVIOUS_DIRECTORSHIPS: (creditReportIndex: number) =>
    `creditReports[${creditReportIndex}].summary.previousDirectorships.value`,
  CREDIT_REPORT_LAST_REQUESTED_AT: (creditReportIndex: number) => `creditReports[${creditReportIndex}].lastRequestedAt`,
  CREDIT_REPORT_OPENED_ACCOUNTS: (creditReportIndex: number) =>
    `creditReports[${creditReportIndex}].summary.openedAccounts.value`,
  CREDIT_REPORT_CLOSED_ACCOUNTS: (creditReportIndex: number) =>
    `creditReports[${creditReportIndex}].summary.closedAccounts.value`,
  CREDIT_REPORT_DEFAULTS_LAST_6MONTHS: (creditReportIndex: number) =>
    `creditReports[${creditReportIndex}].summary.defaultsLast6Months.value`,
  CREDIT_REPORT_DEFAULTS_LAST_12MONTHS: (creditReportIndex: number) =>
    `creditReports[${creditReportIndex}].summary.defaultsLast12Months.value`,
  CREDIT_REPORT_DEFAULTS_LAST_5_TO_7YEARS: (creditReportIndex: number) =>
    `creditReports[${creditReportIndex}].summary.defaultsLast5To7Years.value`,
  CREDIT_REPORT_INSOLVENCIES_AND_ACTIONS: (creditReportIndex: number) =>
    `creditReports[${creditReportIndex}].summary.insolvenciesAndActions.value`,
  CREDIT_REPORT_WORST_OPEN_ACCOUNT_STATUS: (creditReportIndex: number) =>
    `creditReports[${creditReportIndex}].summary.worstOpenAccountStatus.value`,
  CREDIT_REPORT_WORST_OPEN_IN_LAST_12MONTHS: (creditReportIndex: number) =>
    `creditReports[${creditReportIndex}].summary.worstOpenInLast12Months.value`,
  CREDIT_REPORT_WORST_OPEN_IN_LAST_24MONTHS: (creditReportIndex: number) =>
    `creditReports[${creditReportIndex}].summary.worstOpenInLast24Months.value`,
  CREDIT_REPORT_AGE_OF_CREDIT_FILE_IN_MTHS: (creditReportIndex: number) =>
    `creditReports[${creditReportIndex}].summary.ageOfCreditFileInMths.value`,
  CREDIT_REPORT_ENQUIRIES_IN_LAST_5_YEARS: (creditReportIndex: number) =>
    `creditReports[${creditReportIndex}].creditEnquiriesLast5Years`,
  CREDIT_REPORT_OWN_WORST_ACCOUNT_REPAYMENT_IN_LAST_6MONTHS: (creditReportIndex: number) =>
    `creditReports[${creditReportIndex}].summary.ownWorstAccountRepaymentInLast6Months.value`,
  CREDIT_REPORT_NUMBER_OF_COMMERCIAL_ENQUIRIES_IN_LAST_60MONTHS: (creditReportIndex: number) =>
    `creditReports[${creditReportIndex}].summary.numberOfCommercialEnquiriesInLast60Months.value`,
  CREDIT_REPORT_NUMBER_OF_COMMERCIAL_DEFAULTS_IN_LAST_6MONTHS: (creditReportIndex: number) =>
    `creditReports[${creditReportIndex}].summary.numberOfCommercialDefaultsInLast6Months.value`,
  CREDIT_REPORT_NUMBER_OF_COMMERCIAL_DEFAULTS_IN_LAST_12MONTHS: (creditReportIndex: number) =>
    `creditReports[${creditReportIndex}].summary.numberOfCommercialDefaultsInLast12Months.value`,
  CREDIT_REPORT_NUMBER_OF_COMMERCIAL_DEFAULTS_IN_LAST_60_OR_84MONTHS: (creditReportIndex: number) =>
    `creditReports[${creditReportIndex}].summary.numberOfCommercialDefaultsInLast60Or84Months.value`,
  CREDIT_REPORT_ACCOUNTS: (creditReportIndex: number) => `creditReports[${creditReportIndex}].accounts`,
  CREDIT_REPORT_ACCOUNT_ID: (creditReportIndex: number, accountIndex: number) =>
    `creditReports[${creditReportIndex}].accounts[${accountIndex}].accountId`,
  CREDIT_REPORT_ACCOUNT_HOLDER_COUNT: (creditReportIndex: number, accountIndex: number) =>
    `creditReports[${creditReportIndex}].accounts[${accountIndex}].accountHolderCount`,
  CREDIT_REPORT_ACCOUNT_TYPE_CODE: (creditReportIndex: number, accountIndex: number) =>
    `creditReports[${creditReportIndex}].accounts[${accountIndex}].accountType.code`,
  CREDIT_REPORT_RELATIONSHIP_CODE: (creditReportIndex: number, accountIndex: number) =>
    `creditReports[${creditReportIndex}].accounts[${accountIndex}].relationship.code`,
  CREDIT_REPORT_ACCOUNT_OPEN_DATE: (creditReportIndex: number, accountIndex: number) =>
    `creditReports[${creditReportIndex}].accounts[${accountIndex}].accountOpenDate`,
  CREDIT_REPORT_ACCOUNT_CLOSED_DATE: (creditReportIndex: number, accountIndex: number) =>
    `creditReports[${creditReportIndex}].accounts[${accountIndex}].accountClosedDate`,
  CREDIT_REPORT_ACCOUNT_REOPEN_DATE: (creditReportIndex: number, accountIndex: number) =>
    `creditReports[${creditReportIndex}].accounts[${accountIndex}].accountReopenDate`,
};

export const REQUIRED_DOCUMENT_FIELD_PATHS = {
  REQUIRED_DOCUMENT_APPLICANT_ID: (requiredDocumentIndex: number) =>
    `requiredDocuments[${requiredDocumentIndex}].applicantId`,
  REQUIRED_DOCUMENT_CATEGORY: (requiredDocumentIndex: number) => `requiredDocuments[${requiredDocumentIndex}].category`,
  REQUIRED_DOCUMENT_STATUS: (requiredDocumentIndex: number) => `requiredDocuments[${requiredDocumentIndex}].status`,
  REQUIRED_DOCUMENT_ID: (requiredDocumentIndex: number) => `requiredDocuments[${requiredDocumentIndex}].id`,
  REQUIRED_DOCUMENT_ID_TYPE: (requiredDocumentIndex: number) => `requiredDocuments[${requiredDocumentIndex}].idType`,
};

export const RELATED_PARTY_FIELD_PATHS = {
  RELATED_PARTIES: () => `relatedParties`,
  RELATED_PARTY: (relatedPartyIndex: number) => `relatedParties[${relatedPartyIndex}]`,
  RELATED_PARTY_ID: (relatedPartyIndex: number) => `relatedParties[${relatedPartyIndex}].id`,
  RELATED_PARTY_CLIENT_ID: (relatedPartyIndex: number) => `relatedParties[${relatedPartyIndex}].clientId`,
  RELATED_PARTY_APPLICATION_ID: (relatedPartyIndex: number) => `relatedParties[${relatedPartyIndex}].applicationId`,
  RELATED_PARTY_APPLICANT_ID: (relatedPartyIndex: number) => `relatedParties[${relatedPartyIndex}].applicantId`,
  RELATED_PARTY_APPLICANT_CLIENT_ID: (relatedPartyIndex: number) =>
    `relatedParties[${relatedPartyIndex}].applicantClientId`,
  RELATED_PARTY_ASSET_ID: (relatedPartyIndex: number) => `relatedParties[${relatedPartyIndex}].assetId`,
  RELATED_PARTY_EMPLOYMENT_ID: (relatedPartyIndex: number) => `relatedParties[${relatedPartyIndex}].employmentId`,
  RELATED_PARTY_FIRST_NAME: (relatedPartyIndex: number) => `relatedParties[${relatedPartyIndex}].firstName`,
  RELATED_PARTY_LAST_NAME: (relatedPartyIndex: number) => `relatedParties[${relatedPartyIndex}].lastName`,
  RELATED_PARTY_TYPE: (relatedPartyIndex: number) => `relatedParties[${relatedPartyIndex}].type`,
  RELATED_PARTY_BUSINESS_NAME: (relatedPartyIndex: number) => `relatedParties[${relatedPartyIndex}].businessName`,
  RELATED_PARTY_FORMATTED_ADDRESS: (relatedPartyIndex: number) =>
    `relatedParties[${relatedPartyIndex}].address.formatted`,
  RELATED_PARTY_ADDRESS: (relatedPartyIndex: number) => `relatedParties[${relatedPartyIndex}].address`,
  RELATED_PARTY_PHONE: (relatedPartyIndex: number) => `relatedParties[${relatedPartyIndex}].phone`,
  RELATED_PARTY_LICENSED_BUILDER_LANDLINE: (relatedPartyIndex: number) =>
    `relatedParties[${relatedPartyIndex}].licensedBuilderLandline`,
  RELATED_PARTY_TITLE: (relatedPartyIndex: number) => `relatedParties[${relatedPartyIndex}].title`,
  RELATED_PARTY_EMAIL: (relatedPartyIndex: number) => `relatedParties[${relatedPartyIndex}].email`,
  RELATED_PARTY_LICENSE_NUMBER: (relatedPartyIndex: number) => `relatedParties[${relatedPartyIndex}].licenseNumber`,
  RELATED_PARTY_COMPANY_APPLICANT_ID: (relatedPartyIndex: number) =>
    `relatedParties[${relatedPartyIndex}].companyApplicantId`,
  RELATED_PARTY_COMPANY_APPLICANT_CLIENT_ID: (relatedPartyIndex: number) =>
    `relatedParties[${relatedPartyIndex}].companyApplicantClientId`,
  RELATED_PARTY_TRUST_APPLICANT_ID: (relatedPartyIndex: number) =>
    `relatedParties[${relatedPartyIndex}].trustApplicantId`,
  RELATED_PARTY_TRUST_APPLICANT_CLIENT_ID: (relatedPartyIndex: number) =>
    `relatedParties[${relatedPartyIndex}].trustApplicantClientId`,
  RELATED_PARTY_DESCRIPTION: (relatedPartyIndex: number) => `relatedParties[${relatedPartyIndex}].description`,
  RELATED_PARTY_OWNER_ROLE: (relatedPartyIndex: number) => `relatedParties[${relatedPartyIndex}].ownerRole`,
  RELATED_PARTY_OWNER_TYPE: (relatedPartyIndex: number) => `relatedParties[${relatedPartyIndex}].ownerType`,
  RELATED_PARTY_CONTACT_NUMBER: (relatedPartyIndex: number) => `relatedParties[${relatedPartyIndex}].contactNumber`,
  RELATED_PARTY_CONTACT_EMAIL: (relatedPartyIndex: number) => `relatedParties[${relatedPartyIndex}].contactEmail`,

  /**
   * Company Contact specify
   */
  RELATED_PARTY_COMPANY_CONTACT_TYPE: (relatedPartyIndex: number) =>
    `relatedParties[${relatedPartyIndex}].companyContactType`,
  RELATED_PARTY_COMPANY_CONTACT_REGISTERED_FORMATTED_ADDRESS: (relatedPartyIndex: number) =>
    `relatedParties[${relatedPartyIndex}].registeredAddress.formatted`,
  RELATED_PARTY_COMPANY_CONTACT_REGISTERED_ADDRESS: (relatedPartyIndex: number) =>
    `relatedParties[${relatedPartyIndex}].registeredAddress`,
  RELATED_PARTY_COMPANY_CONTACT_TRADING_FORMATTED_ADDRESS: (relatedPartyIndex: number) =>
    `relatedParties[${relatedPartyIndex}].tradingAddress.formatted`,
  RELATED_PARTY_COMPANY_CONTACT_TRADING_ADDRESS: (relatedPartyIndex: number) =>
    `relatedParties[${relatedPartyIndex}].tradingAddress`,
  RELATED_PARTY_COMPANY_CONTACT_MAILING_FORMATTED_ADDRESS: (relatedPartyIndex: number) =>
    `relatedParties[${relatedPartyIndex}].mailingAddress.formatted`,
  RELATED_PARTY_COMPANY_CONTACT_MAILING_ADDRESS: (relatedPartyIndex: number) =>
    `relatedParties[${relatedPartyIndex}].mailingAddress`,
  RELATED_PARTY_COMPANY_CONTACT_PRINCIPAL_PLACE_OF_BUSINESS_FORMATTED_ADDRESS: (relatedPartyIndex: number) =>
    `relatedParties[${relatedPartyIndex}].principalPlaceOfBusiness.formatted`,
  RELATED_PARTY_COMPANY_CONTACT_PRINCIPAL_PLACE_OF_BUSINESS_ADDRESS: (relatedPartyIndex: number) =>
    `relatedParties[${relatedPartyIndex}].principalPlaceOfBusiness`,
  RELATED_PARTY_COMPANY_CONTACT_BUSINESS_NUMBER: (relatedPartyIndex: number) =>
    `relatedParties[${relatedPartyIndex}].contactBusinessNumber`,
  RELATED_PARTY_COMPANY_BENEFICIAL_OWNER_PERCENTAGE: (relatedPartyIndex: number) =>
    `relatedParties[${relatedPartyIndex}].ownerPercentage`,

  /**
   * Trust Settlor specify
   */
  RELATED_PARTY_TRUST_SETTLOR_TYPE: (relatedPartyIndex: number) =>
    `relatedParties[${relatedPartyIndex}].trustSettlorType`,
  RELATED_PARTY_TRUST_SETTLOR_DATE_OF_BIRTH: (relatedPartyIndex: number) =>
    `relatedParties[${relatedPartyIndex}].dateOfBirth`,
  RELATED_PARTY_TRUST_SETTLOR_REASON: (relatedPartyIndex: number) => `relatedParties[${relatedPartyIndex}].reason`,

  /**
   * Trust beneficiaries
   */
  RELATED_PARTY_DISTRIBUTION_PERCENTAGE: (relatedPartyIndex: number) =>
    `relatedParties[${relatedPartyIndex}].distributionPercentage`,
};

export const BROKER_INTERVIEWS_PATHS = {
  BROKER_INTERVIEWS: () => `brokerInterviews`,
  BROKER_INTERVIEW: (brokerInterviewIndex: number) => `brokerInterviews[${brokerInterviewIndex}]`,
  BROKER_INTERVIEW_ID: (brokerInterviewIndex: number) => `brokerInterviews[${brokerInterviewIndex}].id`,
  BROKER_INTERVIEW_CLIENT_ID: (brokerInterviewIndex: number) => `brokerInterviews[${brokerInterviewIndex}].clientId`,
  BROKER_INTERVIEW_APPLICATION_ID: (brokerInterviewIndex: number) =>
    `brokerInterviews[${brokerInterviewIndex}].applicationId`,
  BROKER_INTERVIEW_LOAN_TEARM_SOUGHT_DESCRIPTION: (brokerInterviewIndex: number) =>
    `brokerInterviews[${brokerInterviewIndex}].loanTermSoughtDescription`,
  BROKER_INTERVIEW_REFINANCING_AND_DEBT_CONSOLIDATION_MEETS_OBJECTIVES: (brokerInterviewIndex: number) =>
    `brokerInterviews[${brokerInterviewIndex}].refinancingAndDebtConsolidationMeetsObjectives`,
  BROKER_INTERVIEW_PRODUCT_SELECTION: (brokerInterviewIndex: number) =>
    `brokerInterviews[${brokerInterviewIndex}].productSelection`,
  BROKER_INTERVIEW_ALL_APPLICANTS_UNDERSTAND_ENGLISH: (brokerInterviewIndex: number) =>
    `brokerInterviews[${brokerInterviewIndex}].allApplicantsUnderstandEnglish`,
  BROKER_INTERVIEW_LOCATION_TYPE: (brokerInterviewIndex: number) =>
    `brokerInterviews[${brokerInterviewIndex}].locationType`,
  BROKER_INTERVIEW_LOCATION: (brokerInterviewIndex: number) => `brokerInterviews[${brokerInterviewIndex}].location`,
  BROKER_INTERVIEW_ALL_APPLICANTS_PRESENT: (brokerInterviewIndex: number) =>
    `brokerInterviews[${brokerInterviewIndex}].allApplicantsPresent`,
  BROKER_INTERVIEW_ATTENDEEES: (brokerInterviewIndex: number) => `brokerInterviews[${brokerInterviewIndex}].attendees`,
  BROKER_INTERVIEW_ATTENDEE: (brokerInterviewIndex: number, attendeeIndex: number) =>
    `brokerInterviews[${brokerInterviewIndex}].attendees[${attendeeIndex}]`,
  BROKER_INTERVIEW_ALL_APPLICANTS_BENEFIT: (brokerInterviewIndex: number) =>
    `brokerInterviews[${brokerInterviewIndex}].allApplicantsBenefit`,
  BROKER_INTERVIEW_SUBSTANTIAL_BENEFITS: (brokerInterviewIndex: number) =>
    `brokerInterviews[${brokerInterviewIndex}].substantialBenefit`,
  BROKER_INTERVIEW_SUBSTANTIAL_BENEFIT: (brokerInterviewIndex: number, substantialBenefitIndex: number) =>
    `brokerInterviews[${brokerInterviewIndex}].substantialBenefit[${substantialBenefitIndex}]`,
  BROKER_INTERVIEW_SUBSTANTIAL_BENEFIT_APPLICANT_ID: (brokerInterviewIndex: number, substantialBenefitIndex: number) =>
    `brokerInterviews[${brokerInterviewIndex}].substantialBenefit[${substantialBenefitIndex}].applicantId`,
  BROKER_INTERVIEW_SUBSTANTIAL_BENEFIT_CO_APPLICANT_BENEFIT: (
    brokerInterviewIndex: number,
    substantialBenefitIndex: number
  ) => `brokerInterviews[${brokerInterviewIndex}].substantialBenefit[${substantialBenefitIndex}].coApplicantBenefit`,
  BROKER_INTERVIEW_SUBSTANTIAL_BENEFIT_BENEFIT_ENQUIRIES: (
    brokerInterviewIndex: number,
    substantialBenefitIndex: number
  ) => `brokerInterviews[${brokerInterviewIndex}].substantialBenefit[${substantialBenefitIndex}].benefitEnquiries`,
  BROKER_INTERVIEW_SUBSTANTIAL_BENEFIT_BENEFIT_ENQUIRY: (
    brokerInterviewIndex: number,
    substantialBenefitIndex: number,
    benefitEnquiryIndex: number
  ) =>
    `brokerInterviews[${brokerInterviewIndex}].substantialBenefit[${substantialBenefitIndex}].benefitEnquiries[${benefitEnquiryIndex}]`,
  BROKER_INTERVIEW_SUBSTANTIAL_BENEFIT_BENEFIT_ENQUIRIES_DESCRIPTION: (
    brokerInterviewIndex: number,
    substantialBenefitIndex: number
  ) =>
    `brokerInterviews[${brokerInterviewIndex}].substantialBenefit[${substantialBenefitIndex}].benefitEnquiriesDescription`,
  BROKER_INTERVIEW_SUBSTANTIAL_BENEFIT_CO_APPLICANT_REASON: (
    brokerInterviewIndex: number,
    substantialBenefitIndex: number
  ) => `brokerInterviews[${brokerInterviewIndex}].substantialBenefit[${substantialBenefitIndex}].coApplicantReason`,
  BROKER_INTERVIEW_SUBSTANTIAL_BENEFIT_SUSPECT_EXPERIENCING_FINANCIAL_ABUSE: (
    brokerInterviewIndex: number,
    substantialBenefitIndex: number
  ) =>
    `brokerInterviews[${brokerInterviewIndex}].substantialBenefit[${substantialBenefitIndex}].suspectExperiencingFinancialAbuse`,
  BROKER_INTERVIEW_SUBSTANTIAL_BENEFIT_UNDERSTANDS_CO_APPLICANT_OBLIGATIONS: (
    brokerInterviewIndex: number,
    substantialBenefitIndex: number
  ) =>
    `brokerInterviews[${brokerInterviewIndex}].substantialBenefit[${substantialBenefitIndex}].understandsCoApplicantObligations`,
};

export const BROKER_INTERVIEWS_GUARANTOR_PATHS = {
  BROKER_INTERVIEWS_GUARANTORS: () => `brokerInterviewsGuarantor`,
  BROKER_INTERVIEWS_GUARANTOR: (brokerInterviewsGuarantorIndex: number) =>
    `brokerInterviewsGuarantor[${brokerInterviewsGuarantorIndex}]`,
  BROKER_INTERVIEWS_GUARANTOR_APPLICANT_ID: (brokerInterviewsGuarantorIndex: number) =>
    `brokerInterviewsGuarantor[${brokerInterviewsGuarantorIndex}].applicantId`,
  BROKER_INTERVIEWS_GUARANTOR_HAS_BROKER_DECLARATION: (brokerInterviewsGuarantorIndex: number) =>
    `brokerInterviewsGuarantor[${brokerInterviewsGuarantorIndex}].hasBrokerDeclaration`,
  BROKER_INTERVIEWS_GUARANTOR_CONFIRM_COULD_MEET_LOAN_REPAYMENTS: (brokerInterviewsGuarantorIndex: number) =>
    `brokerInterviewsGuarantor[${brokerInterviewsGuarantorIndex}].confirmCouldMeetLoanRepayments`,
  BROKER_INTERVIEWS_GUARANTOR_CONFIRM_WOULD_SELL_FAMILY_HOME: (brokerInterviewsGuarantorIndex: number) =>
    `brokerInterviewsGuarantor[${brokerInterviewsGuarantorIndex}].confirmWouldSellFamilyHome`,
  BROKER_INTERVIEWS_GUARANTOR_INDEPENDENT_ADVICE_TYPE_REQUIRED: (brokerInterviewsGuarantorIndex: number) =>
    `brokerInterviewsGuarantor[${brokerInterviewsGuarantorIndex}].independentAdviceTypeRequired`,
  BROKER_INTERVIEWS_GUARANTOR_INTERVIEW_DATE: (brokerInterviewsGuarantorIndex: number) =>
    `brokerInterviewsGuarantor[${brokerInterviewsGuarantorIndex}].interviewDate`,
  BROKER_INTERVIEWS_GUARANTOR_IS_ONLY_PERSON_PRESENT: (brokerInterviewsGuarantorIndex: number) =>
    `brokerInterviewsGuarantor[${brokerInterviewsGuarantorIndex}].isOnlyPersonPresent`,
  BROKER_INTERVIEWS_GUARANTOR_LOCATION: (brokerInterviewsGuarantorIndex: number) =>
    `brokerInterviewsGuarantor[${brokerInterviewsGuarantorIndex}].location`,
  BROKER_INTERVIEWS_GUARANTOR_LOCATION_DESCRIPTION: (brokerInterviewsGuarantorIndex: number) =>
    `brokerInterviewsGuarantor[${brokerInterviewsGuarantorIndex}].locationDescription`,
  BROKER_INTERVIEWS_GUARANTOR_UNDERSTANDS_GUARANTEE_SIGNING_PERIOD: (brokerInterviewsGuarantorIndex: number) =>
    `brokerInterviewsGuarantor[${brokerInterviewsGuarantorIndex}].understandsGuaranteeSigningPeriod`,
  BROKER_INTERVIEWS_GUARANTOR_UNDERSTANDS_SECURITY_GUARANTEE: (brokerInterviewsGuarantorIndex: number) =>
    `brokerInterviewsGuarantor[${brokerInterviewsGuarantorIndex}].understandsSecurityGuarantee`,
  BROKER_INTERVIEWS_GUARANTOR_UNDERSTANDS_ENGLISH: (brokerInterviewsGuarantorIndex: number) =>
    `brokerInterviewsGuarantor[${brokerInterviewsGuarantorIndex}].understandsEnglish`,
  BROKER_INTERVIEWS_GUARANTOR_DOCUMENTATION_DELIVERY_METHOD: (brokerInterviewsGuarantorIndex: number) =>
    `brokerInterviewsGuarantor[${brokerInterviewsGuarantorIndex}].documentationDeliveryMethod`,
  BROKER_INTERVIEWS_GUARANTOR_IS_UNDER_POWER_OF_ATTORNEY: (brokerInterviewsGuarantorIndex: number) =>
    `brokerInterviewsGuarantor[${brokerInterviewsGuarantorIndex}].isUnderPowerOfAttorney`,
  BROKER_INTERVIEWS_GUARANTOR_HAS_LENDER_SPECIFIC_BROKER_DECLARATION: (brokerInterviewsGuarantorIndex: number) =>
    `brokerInterviewsGuarantor[${brokerInterviewsGuarantorIndex}].hasLenderSpecificBrokerDeclaration`,
};

export const POST_PRODUCT_SELECT_PATHS = {
  POST_PRODUCT_SELECTS: () => `postProductSelect`,
  POST_PRODUCT_SELECT_ENTITY_ID: (postProductSelectIndex: number) =>
    `postProductSelect[${postProductSelectIndex}].entityId`,
  POST_PRODUCT_SELECT_ENTITY_TYPE: (postProductSelectIndex: number) =>
    `postProductSelect[${postProductSelectIndex}].entityType`,
  POST_PRODUCT_SELECT_ENTITY_INDEX: (postProductSelectIndex: number) =>
    `postProductSelect[${postProductSelectIndex}].entityIndex`,
  POST_PRODUCT_SELECT_QUESTIONS: (postProductSelectIndex: number) =>
    `postProductSelect[${postProductSelectIndex}].questions`,
  POST_PRODUCT_SELECT_QUESTION: (postProductSelectIndex: number, questionIndex: number) =>
    `postProductSelect[${postProductSelectIndex}].questions[${questionIndex}]`,
};

export const CONVEYANCING_FIELD_PATHS = {
  CONVEYANCING_STATUS: `conveyancing.lendiStatus`,
  CONVEYANCING_INTENT: `conveyancing.intent`,
  CONVEYANCING_PROPERTY_ID: `conveyancing.property.id`,
  CONVEYANCING_CUSTOMER_ID: `conveyancing.customerId`,
  CONVEYANCING_SOURCE_ID: `conveyancing.sourceId`,
};

export const TEMP_FIELD_PATHS = {
  TEMP_APPLICANT_COUNT: () => `temp.applicantCount`,
  TEMP_FIELD: () => `temp.temporaryField`,
  TEMP_OWE_MONEY_ON_LAND: () => `temp.oweMoneyOnLand`,
  TEMP_PROPERTY_COUNT: () => `temp.propertyCount`,
  TEMP_DO_YOU_WANT_GUARANTOR: () => `temp.doYouWantGuarantor`,
  TEMP_SKIP_VALIDATION_FIELDS: () => `temp.skipValidationFields`,
  TEMP_SELECTED_APPLICANT_ID: () => `temp.selectedApplicantId`,
};

export const FIELD_PATHS = {
  ...APPLICANT_FIELD_PATHS,
  ...APPLICATION_FIELD_PATHS,
  ...ASSET_FIELD_PATHS,
  ...BROKER_INTERVIEWS_PATHS,
  ...BROKER_INTERVIEWS_GUARANTOR_PATHS,
  ...COMPANIES_FIELD_PATHS,
  ...CONVEYANCING_FIELD_PATHS,
  ...CREDIT_REPORT_FIELD_PATHS,
  ...CUSTOMER_FIELD_PATHS,
  ...EMPLOYMENT_FIELD_PATHS,
  ...COMPANIES_FIELD_PATHS,
  ...EXPENSE_FIELD_PATHS,
  ...FINANCIAL_SITUATION_PATHS,
  ...INCOMES_FIELD_PATHS,
  ...INVITATIONS_FIELD_PATHS,
  ...LIABILITY_FIELD_PATHS,
  ...POST_PRODUCT_SELECT_PATHS,
  ...PRODUCT_PREFERENCE_FIELD_PATHS,
  ...REQUIRED_DOCUMENT_FIELD_PATHS,
  ...POST_PRODUCT_SELECT_PATHS,
  ...RELATED_PARTY_FIELD_PATHS,
  ...TEMP_FIELD_PATHS,
};
